import type { ButtonProps } from "antd";
import styled from "styled-components";

import { ActionButtonHtmlStyle, ActionButtonStyle } from "./ButtonStyle";

export const PrimaryButton = styled(ActionButtonStyle).attrs((props: ButtonProps) => ({
    htmlType: props.htmlType || "button",
    className: "aevi-button aevi-button-primary",
}))``;

export const SecondaryButton = styled(ActionButtonStyle).attrs(() => ({ className: "aevi-button aevi-button-secondary" }))``;

export const DangerButton = styled(ActionButtonStyle).attrs(() => ({ className: "aevi-button aevi-button-danger" }))``;

export const BlackButton = styled(ActionButtonStyle).attrs(() => ({ className: "aevi-button aevi-button-black" }))``;

export const PrimaryButtonHtml = styled(ActionButtonHtmlStyle).attrs(() => ({ className: "aevi-button aevi-button-primary" }))``;

export const SecondaryButtonHtml = styled(ActionButtonHtmlStyle).attrs(() => ({ className: "aevi-button aevi-button-secondary" }))``;
